/** @jsxImportSource @emotion/react */
import * as s from './style';
import React from 'react';
import PopulationMoveRouteTable from 'components/charts/PopulationMoveRouteTable';
import MapPopupFrame from './MapPopupFrame';

const PopMoveRoutePopup = ({
    movPopParams,
    selectedMoveRouteInfo,
    selectedMoveRouteInfoItems,
    handleMoveRoutePopupClose,
    isOpen
}) => {
    const hasRouteData = Boolean(selectedMoveRouteInfo);

    return (
        <MapPopupFrame
            popupId='popmoveroute_popup'
            isVisible={true}
            title="인구이동"
            onClose={handleMoveRoutePopupClose}
            containerCss={s.mapPopupContainer}
        >
            <div className="map-popup-item">
                <PopulationMoveRouteTable
                    title={selectedMoveRouteInfo?.value ?? ''}
                    params={movPopParams}
                    data={selectedMoveRouteInfo}
                    items={selectedMoveRouteInfoItems}
                />
            </div>
        </MapPopupFrame>
    );
};

export default PopMoveRoutePopup;
